<template>
  <v-layout justify-center>
    <v-flex xs12 sm6 md5 lg5>
      <v-card style="margin-top: 50px">
        <v-card-title primary-title>
          <div style="width: 100%">
            <h3 class="headline mb-0">Console Login</h3>
            <v-form
              @submit="processLogin"
              v-model="login"
              style="margin-top: 10px"
            >
              <v-select
                v-model="host"
                label="Host"
                @change="setConnection"
                :cache-items="true"
                autocomplete="off"
                outlined
                :items="connections"
                required
                :messages="
                  connection_status == 'connected'
                    ? connection_version != undefined
                      ? 'Version: ' + connection_version
                      : 'Version: N/A'
                    : connection_status == 'connecting'
                    ? 'Connecting...'
                    : 'Failed to connect'
                "
              >
                <div slot="append-outer">
                  <i
                    class="fad fa-circle"
                    style="font-size: 16px; display: inline"
                    :title="
                      connection_status == 'connected'
                        ? 'Available'
                        : connection_status == 'connecting'
                        ? 'Connecting...'
                        : 'Failed to connect'
                    "
                    :style="{
                      color:
                        connection_status == 'connected'
                          ? 'green'
                          : connection_status == 'connecting'
                          ? 'orange'
                          : 'red',
                    }"
                  ></i>
                </div>
              </v-select>
              <v-text-field
                value=""
                v-model="email"
                label="Email"
                outlined
                autocomplete="off"
                :rules="emailRules"
                required
              ></v-text-field>
              <v-text-field
                value=""
                type="password"
                label="Password"
                outlined
                v-model="password"
                :rules="passwordRules"
                required
              ></v-text-field>
              <div style="text-align: center">
                <v-btn type="submit" :loading="l_login">login</v-btn>
              </div>
            </v-form>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import Cookies from "js-cookie";
import { Notifications } from "../notification";
import { UserSessionMod } from "../user_session";
import { User } from "../logic/User";
import updateAPIEndpoint from "../logic/Vars";
import Vue from "vue";
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      login: false,
      host: "",
      connections: [],
      connection_status: "not_connected",
      connection_version: undefined,
      email: "",
      password: "",

      l_login: false,

      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      passwordRules: [(v) => !!v || "Password is required"],
    };
  },
  mounted() {
    this.setTitle("Login");

    this.loadConnections();
    var host = localStorage.getItem("api_host");
    if (host == undefined) {
      this.host = Vue.prototype.$API_ENDPOINT;
    } else {
      this.host = host;
      updateAPIEndpoint(this.host);
      Vue.prototype.$API_ENDPOINT = this.host;
    }
    this.checkConnection();
  },
  methods: {
    setConnection() {
      switch (this.host) {
        case "_add":
          setTimeout(
            function () {
              this.host = Vue.prototype.$API_ENDPOINT;
            }.bind(this),
            200
          );
          this.addNewConnection();
          break;
          case "_clear":
          setTimeout(
            function () {
              this.host = Vue.prototype.$API_ENDPOINT;
            }.bind(this),
            200
          );
          this.clearConnections();
          break;
        default:
          var connection_url = this.host;
          Vue.prototype.$API_ENDPOINT = connection_url;
          updateAPIEndpoint(connection_url);
          localStorage.setItem("api_host", connection_url);
          this.checkConnection();
          break;
      }
    },
    addNewConnection() {
      var connection_url = prompt("Enter a new connection", "");
      if (
        connection_url == "" ||
        connection_url == null ||
        connection_url == undefined
      ) {
        return;
      } else {
        if (this.validURL(connection_url)) {
          // Remove the slash at the end, if given.
          if (connection_url.charAt(connection_url.length - 1) === "/") {
            connection_url = connection_url.slice(0, connection_url.length - 1);
          }

          var hosts = localStorage.getItem("api_hosts") || "[]";
          var jHosts = JSON.parse(hosts);

          jHosts.push({
            url: connection_url,
          });

          localStorage.setItem("api_hosts", JSON.stringify(jHosts));
          this.loadConnections();
        } else {
          Notifications.show("Please provide a valid url.");
        }
      }
    },
    validURL(str) {
      return str.startsWith("http://") || str.startsWith("https://");
    },
    loadConnections() {
      var connections = [];

      // Default server
      connections.push({
        value: "https://api.schmuckli.cloud",
        text: "[PROD] https://api.schmuckli.cloud",
      });
      // Test server
      connections.push({
        value: "https://api.test.schmuckli.cloud",
        text: "[TEST] https://api.test.schmuckli.cloud",
      });
      // Local server running with Docker
      connections.push({
        value: "http://localhost:4000",
        text: "[LOCAL] http://localhost:4000",
      });

      var hosts = localStorage.getItem("api_hosts") || "[]";
      var jHosts = JSON.parse(hosts);

      for (var host of jHosts) {
        connections.push({
          value: host.url,
          text: host.url,
        });
      }

      // Manage fields
      connections.push({
        value: "_add",
        text: "+ Add connection",
      });
      connections.push({
        value: "_clear",
        text: "- Clear custom connections",
      });

      this.connections = connections;
    },
    async checkConnection() {
      try {
        this.connection_status = "connecting";
        this.connection_version = undefined;
        var response = await axios({
          url: this.host + "/index.php",
          method: "GET",
          params: {
            info: true,
          },
        });
        if (response.status === 200) {
          this.connection_version = response.data.version;
          this.connection_status = "connected";
        } else {
          this.connection_status = "failed";
        }
      } catch (e) {
        this.connection_status = "failed";
      }
    },
    clearConnections() {
      if (
        confirm("Do you really want to delete all your custom connections?")
      ) {
        localStorage.removeItem("api_hosts");
        window.location.reload();
      }
    },
    processLogin(e) {
      e.preventDefault();

      this.l_login = true;

      User.login(this.email, this.password)
        .then(
          function (response) {
            if (response.status === 200) {
              //Login was successful
              Cookies.set("_console_token", response.body._console_token, {
                expires: 7,
              }); //To stay 7 days logged in
              UserSessionMod.setToken(response.body._console_token);
              this.$router.replace("dashboard");
              Notifications.show("Welcome back.");
            } else {
              Notifications.show(response.message);
            }
            this.l_login = false;
          }.bind(this)
        )
        .catch(() => {
          this.l_login = false;
          Notifications.show("The host cannot be reached.");
        });
    },
  },
};
</script>
